import { render, staticRenderFns } from "./specification-categories.vue?vue&type=template&id=1da1a37c&"
import script from "./specification-categories.vue?vue&type=script&lang=js&"
export * from "./specification-categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports